import { __assign } from "tslib";
import React from 'react';
import { useVirtualized } from './useVirtualized';
export function VirtualCollection(props) {
    var collection = props.collection, children = props.children, estimate = props.estimate, focusedIndex = props.focusedIndex;
    var _a = useVirtualized({
        items: collection,
        renderElement: function (_a) {
            var element = _a.element, style = _a.style;
            return (React.createElement("div", { style: style }, children({ element: element })));
        },
        estimate: estimate,
        focusedIndex: focusedIndex,
    }), containerProps = _a.containerProps, innerProps = _a.innerProps, virtualItems = _a.virtualItems;
    return (React.createElement("div", { ref: containerProps.ref, style: __assign(__assign({}, containerProps.style), { height: props.height, maxHeight: props.maxHeight }) },
        React.createElement("div", { style: innerProps.style }, virtualItems)));
}
